<template>
  <div>
    <aside class="filter-aside">
      <h3 class="filter-title">舆情类别</h3>
      <h4 class="filter-subtitle">负面</h4>
      <ul>
        <li
          class="filter-item filter-all negative"
          :class="{selected: typeSelected.isNegative && typeSelected.isAll}"
          @click="selectAllTypes(true)"
        >全部负面</li>
        <li
          class="filter-item"
          v-for="(item, i) in types.negative"
          :key="i"
          @click="singleSelectType(item, true)"
          :class="{selected: typeSelected.multipleValues.indexOf(item) >= 0 || typeSelected.value === item, multiple: typeSelected.multipleValues.indexOf(item) >= 0}"
        >
          <span
            class="color-checkbox negative"
            :class="{checked: typeSelected.multipleValues.indexOf(item) >= 0}"
            @click.stop="multipleSelectType(item, true)"
          ></span>
          {{ item }}
        </li>
      </ul>
      <h4 class="filter-subtitle-positive">正面</h4>
      <ul>
        <li
          class="filter-item filter-all positive"
          :class="{selected: !typeSelected.isNegative && typeSelected.isAll}"
          @click="selectAllTypes(false)"
        >全部正面</li>
        <li
          class="filter-item"
          v-for="(item, i) in types.positive"
          :key="i"
          @click="singleSelectType(item, false)"
          :class="{selected: typeSelected.multipleValues.indexOf(item) >= 0 || typeSelected.value === item, multiple: typeSelected.multipleValues.indexOf(item) >= 0}"
        >
          <span
            class="color-checkbox positive"
            :class="{checked: typeSelected.multipleValues.indexOf(item) >= 0}"
            @click.stop="multipleSelectType(item, false)"
          ></span>
          {{ item }}
        </li>
      </ul>
    </aside>
    <div class="area-news-content">
      <div class="all-provinces">
        <div class="province-map">
          <h3 style="color: white">舆情分布情况</h3>
          <div class="province-map-content"></div>
        </div>
        <div class="province-top">
          <sn-ranking
            :data="regionRankingData"
            :isShowIndex="true"
            :emitData="emitRegionData"
            :sentiment="sentimentColor"
            :default-message="region"
          >
            <div class="ranking-header">{{sentiment}}相关排名</div>
          </sn-ranking>
        </div>
      </div>
      <div class="show-time">
        <div class="show-time-title">选择时间段</div>
        <div class="show-time-content">{{showStartDate}} - {{showEndDate}}</div>
      </div>
      <interval-selector
        :min="dateInterval.min"
        :max="dateInterval.max"
        :step="dateInterval.step"
        :milestones="dateInterval.milestones"
        :default-range="dateInterval.defaultRange"
        :onchange="dateInterval.onchange"
      ></interval-selector>
      <div class="one-province-detail">
        <div class="area-news-bottom">
          <div class="area-news-list">
            <div class="area-news-list-header">
              <div class="news-region">{{region}}</div>
              <div class="news-sentiment">{{sentiment}}</div>
              <div class="news-word">相关新闻</div>
            </div>
            <div v-loading="isLoading">
              <news-list-item v-for="(item, idx) in newsData" :data="item" :key="idx"></news-list-item>
            </div>
          </div>
          <div class="pager" v-if="totalCount > 0">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="totalCount"
            ></el-pagination>
          </div>
        </div>
        <div class="type-top">
          <sn-ranking :data="riskData" :emitData="emitRiskData">
            <div class="ranking-header">{{region}}舆情类别排名</div>
          </sn-ranking>
        </div>
      </div>
    </div>
    <div class="news-dialog">
      <el-dialog :visible.sync="dialogVisible" width="900" :before-close="handleClose">
        <div class="news-dialog_title">{{dialogTitleRisk}}</div>
        <div class="news-list-box" v-loading="isLoading">
          <news-list-item v-for="(item, idx) in newsDialogData" :data="item" :key="idx"></news-list-item>
          <div class="no-data-container" v-if="!isLoading && !totalCount">
            <no-data></no-data>
          </div>
          <div class="pager" v-if="totalDialogCount > 0">
            <el-pagination
              @current-change="handleDialogCurrentChange"
              :current-page.sync="currentDialogPage"
              :page-size="pageDialogSize"
              layout="prev, pager, next, jumper"
              :total="totalDialogCount"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ChinaProvinceMap from '../components/maps/ChinaProvinceMap';
import IntervalSelector from '../components/common/IntervalSelector';
import SnRanking from '@/components/common/SnRanking';
import NewsListItem from '@/components/news-monitor/NewsListItem';
import questionQuery from '@/rest/questionQuery';
import NoData from '@/components/common/NoData';

export default {
  name: 'AreaNewsPage',
  components: {
    IntervalSelector,
    SnRanking,
    NewsListItem,
    NoData
  },
  data() {
    const that = this;
    return {
      showStartDate: '',
      showEndDate: '',
      dateRange: [],
      optionRegion: 'region',
      mapColor: 0,
      sentimentColor: 'negative',
      newsDialogData: [],
      currentDialogPage: 1,
      pageDialogSize: 15,
      isLoading: false,
      dialogVisible: false,
      isRiskDialog: false,
      dialogTitleRisk: '',
      regionRankingData: [],
      newsData: [],
      riskData: [],
      currentPage: 1,
      pageSize: 15,
      totalDialogCount: 0,
      totalCount: 0,
      rerender: true,
      region: '北京市',
      sentiment: '负面',
      types: {
        positive: [],
        negative: []
      },
      typeSelected: {
        // 标志选择哪个类别
        isNegative: true,
        // 标志是否选择所有
        isAll: true,
        // 多选值
        multipleValues: [],
        // 单选值
        value: null
      },
      provinceMap: null,
      dateInterval: {
        min: 0,
        max: 24,
        step: 1,
        milestones: {
          // 0: 2017,
          // 12: 2018
        },
        defaultRange: [0, 24],
        onchange(start, end) {
          let difference = null;
          let remainder = null;
          let consule = null;
          const standardIndex = Object.keys(that.dateInterval.milestones)[0];
          const standardYear = that.dateInterval.milestones[standardIndex];
          if (start > standardIndex) {
            difference = start - standardIndex;
            remainder = difference % 12;
            consule = Math.floor(difference / 12);
            that.selectedDate.startYear = standardYear + consule;
            that.selectedDate.startMonth = remainder + 1;
          } else if (start < standardIndex) {
            difference = standardIndex - start;
            remainder = difference % 12;
            consule = Math.floor(difference / 12);
            if (remainder === 0) {
              that.selectedDate.startYear = standardYear - consule;
              that.selectedDate.startMonth = remainder;
            } else {
              that.selectedDate.startYear = standardYear - consule - 1;
              that.selectedDate.startMonth = 13 - remainder;
            }
          } else {
            that.selectedDate.startYear = standardYear;
            that.selectedDate.startMonth = 1;
          }

          if (end > standardIndex) {
            difference = end - standardIndex;
            remainder = difference % 12;
            consule = Math.floor(difference / 12);
            that.selectedDate.endYear = standardYear + consule;
            that.selectedDate.endMonth = remainder + 1;
          } else if (end < standardIndex) {
            difference = standardIndex - end;
            remainder = difference % 12;
            consule = Math.floor(difference / 12);
            if (remainder === 0) {
              that.selectedDate.endYear = standardYear - consule;
              that.selectedDate.endMonth = remainder;
            } else {
              that.selectedDate.endYear = standardYear - consule - 1;
              that.selectedDate.endMonth = 13 - remainder;
            }
          } else {
            that.selectedDate.endYear = standardYear;
            that.selectedDate.endMonth = 1;
          }
          const isStartZero = that.selectedDate.startMonth < 10 ? 0 : '';
          const isEndZero = that.selectedDate.endMonth < 10 ? 0 : '';
          that.showStartDate = `${that.selectedDate.startYear}/${isStartZero}${that.selectedDate.startMonth}`;
          that.showEndDate = `${that.selectedDate.endYear}/${isEndZero}${that.selectedDate.endMonth}`;
          that.startDate = `${that.selectedDate.startYear}-${isStartZero}${that.selectedDate.startMonth}`;
          that.endDate = `${that.selectedDate.endYear}-${isEndZero}${that.selectedDate.endMonth}`;
          that.dateRange = [that.startDate, that.endDate];
          that.fetchNewsList();
          that.fetchRegionRanking();
        }
      },
      selectedDate: {
        startYear: 0,
        startMonth: 0,
        endYear: 0,
        endMonth: 0
      }
    };
  },
  methods: {
    setDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      this.dateInterval.milestones[24 - 12 - month] = year - 1;
      this.dateInterval.milestones[24 - month] = year;
    },
    handleDialogCurrentChange(page) {
      this.currentDialogPage = page;
      this.fetchDialogNewsList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    fetchRegionData() {
      const date = new Date();
      const isZero = date.getMonth() < 9 ? 0 : '';
      this.showStartDate = `${date.getFullYear() - 2}/${isZero}${date.getMonth() + 2}`;
      this.showEndDate = `${date.getFullYear()}/${isZero}${date.getMonth() + 1}`;
      this.startDate = `${date.getFullYear() - 2}-${isZero}${date.getMonth() + 2}`;
      this.endDate = `${date.getFullYear()}-${isZero}${date.getMonth() + 1}`;
      this.dateRange.push(this.startDate, this.endDate);
      questionQuery.getRiskBar('', this.startDate, this.endDate).then(result => {
        this.types.negative = result.negative;
        this.types.positive = result.positive;
        questionQuery.regionRankWithRisks(this.types.negative, this.dateRange).then(res => {
          const data = {};
          this.regionRankingData = res.map(item => {
            return {
              message: item.region,
              num: item.num
            };
          });
          let key = '';
          let value = '';
          for (let i = 0; i < this.regionRankingData.length; i++) {
            key = this.regionRankingData[i].message;
            value = this.regionRankingData[i].num;
            data[key] = value;
          }
          this.provinceMap.setProvinceValues(data).draw({ color: 1, borderColor: 1 });
        });
        this.fetchNewsList();
      });
    },
    emitRegionData(item) {
      this.region = item.message;
      this.provinceMap.select(this.region);
      questionQuery.getRiskRankWithRegion(this.region, this.startDate, this.endDate).then(result => {
        this.riskData = result.map(itemData => {
          return {
            message: itemData.risk,
            num: itemData.num,
            sentiment: itemData.sentiment
          };
        });
      });
      this.fetchNewsList();
    },
    fetchDialogNewsList() {
      let params = {};
      if (this.types.positive.includes(this.dialogTitleRisk)) {
        params = {
          pageNum: this.currentDialogPage,
          pageSize: this.pageDialogSize,
          positive: [this.dialogTitleRisk],
          region: this.region,
          date: this.dateRange,
          option: this.optionRegion
        };
      } else {
        params = {
          pageNum: this.currentDialogPage,
          pageSize: this.pageDialogSize,
          negative: [this.dialogTitleRisk],
          region: this.region,
          date: this.dateRange,
          option: this.optionRegion
        };
      }
      this.isLoading = true;
      questionQuery.getNewsList(params).then(res => {
        this.isLoading = false;
        this.newsDialogData = res.pageItems;
        this.totalDialogCount = res.totalCount;
        this.dialogVisible = true;
      });
    },
    emitRiskData(item) {
      this.dialogTitleRisk = item.message;
      this.fetchDialogNewsList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchNewsList();
    },
    selectAllTypes(isNegative) {
      this.typeSelected.isAll = true;
      this.typeSelected.multipleValues = [];
      this.typeSelected.value = '';
      this.typeSelected.isNegative = isNegative;
      this.fetchRegionRanking();
      this.fetchNewsList();
    },
    multipleSelectType(tp, isNegative) {
      if (this.typeSelected.isNegative !== isNegative) {
        this.typeSelected.multipleValues = [];
      }
      this.typeSelected.isNegative = isNegative;
      this.typeSelected.isAll = false;
      this.typeSelected.value = null;
      const idx = this.typeSelected.multipleValues.indexOf(tp);
      if (idx >= 0) {
        this.typeSelected.multipleValues.splice(idx, 1);
        if (!this.typeSelected.multipleValues) {
          this.typeSelected.isAll = true;
        }
      } else {
        this.typeSelected.multipleValues.push(tp);
      }
      this.fetchRegionRanking();
      this.fetchNewsList();
    },
    singleSelectType(tp, isNegative) {
      this.typeSelected.isAll = false;
      this.typeSelected.multipleValues = [];
      this.typeSelected.value = tp;
      this.typeSelected.isNegative = isNegative;
      this.fetchRegionRanking();
      this.fetchNewsList();
    },
    fetchRegionRanking() {
      let data = [];
      if (this.typeSelected.isNegative) {
        this.sentimentColor = 'negative';
        if (this.typeSelected.isAll) {
          data = this.types.negative;
        } else if (this.typeSelected.value) {
          data = [this.typeSelected.value];
        } else {
          data = this.typeSelected.multipleValues;
        }
      } else {
        this.sentimentColor = 'positive';
        if (this.typeSelected.isAll) {
          data = this.types.positive;
        } else if (this.typeSelected.value) {
          data = [this.typeSelected.value];
        } else {
          data = this.typeSelected.multipleValues;
        }
      }
      questionQuery.regionRankWithRisks(data, this.dateRange).then(res => {
        const dataObject = {};
        this.regionRankingData = res.map(item => {
          return {
            message: item.region,
            num: item.num
          };
        });
        let key = '';
        let value = '';
        for (let i = 0; i < this.regionRankingData.length; i++) {
          key = this.regionRankingData[i].message;
          value = this.regionRankingData[i].num;
          dataObject[key] = value;
        }
        const params = {
          color: this.typeSelected.isNegative ? 1 : 2,
          borderColor: this.typeSelected.isNegative ? 1 : 2
        };
        this.provinceMap.setProvinceValues(dataObject).draw(params);
        this.provinceMap.select(this.region);
      });
    },
    fetchNewsList() {
      let params = {};
      if (this.typeSelected.isNegative) {
        if (this.typeSelected.isAll) {
          this.sentiment = '负面';
          params = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            negative: this.types.negative,
            region: this.region,
            date: this.dateRange,
            option: this.optionRegion
          };
        } else {
          let data = [];
          if (this.typeSelected.value) {
            this.sentiment = this.typeSelected.value;
            data = [this.typeSelected.value];
          } else {
            this.sentiment = '所选类别';
            data = this.typeSelected.multipleValues;
          }
          params = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            negative: data,
            region: this.region,
            date: this.dateRange,
            option: this.optionRegion
          };
        }
      } else if (this.typeSelected.isAll) {
        this.sentiment = '正面';
        params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          positive: this.types.positive,
          region: this.region,
          date: this.dateRange,
          option: this.optionRegion
        };
      } else {
        let data = [];
        if (this.typeSelected.value) {
          this.sentiment = this.typeSelected.value;
          data = [this.typeSelected.value];
        } else {
          this.sentiment = '所选类别';
          data = this.typeSelected.multipleValues;
        }
        params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          positive: data,
          region: this.region,
          date: this.dateRange,
          option: this.optionRegion
        };
      }
      this.isLoading = true;
      questionQuery.getNewsList(params).then(res => {
        this.isLoading = false;
        this.newsData = res.pageItems;
        this.totalCount = res.totalCount;
      });
      questionQuery.getRiskRankWithRegion(this.region, this.startDate, this.endDate).then(result => {
        this.riskData = result.map(item => {
          return {
            message: item.risk,
            num: item.num,
            sentiment: item.sentiment
          };
        });
      });
    },
    resizeMapHeight() {
      const mapElem = this.$el.querySelector('.province-map-content');
      const w = mapElem.offsetWidth;
      const ratio = 5 / 12;
      mapElem.style.height = `${w * ratio}px`;
    },
    windowResizeListener() {
      this.resizeMapHeight();
      const params = {
        color: this.typeSelected.isNegative ? 1 : 2,
        borderColor: this.typeSelected.isNegative ? 1 : 2
      };
      this.provinceMap.draw(params);
      this.provinceMap.select(this.region);
    }
  },
  created() {
    this.setDate();
  },
  mounted() {
    // 调整地图高度
    this.resizeMapHeight();
    window.addEventListener('resize', this.windowResizeListener);
    this.provinceMap = new ChinaProvinceMap({
      elem: this.$el.querySelector('.province-map-content'),
      onselectchange: provinceNames => {
        if (provinceNames) {
          this.emitRegionData({ message: provinceNames[0] });
        }
      }
    });
    this.provinceMap.draw();
    this.provinceMap.select('北京');
    this.fetchRegionData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResizeListener);
    this.provinceMap.destroy();
  }
};
</script>

<style lang="scss" scoped>
.page-content {
  background-color: #19191f;
}
.filter-aside {
  width: 232px;
  background-color: #343239;
  position: fixed;
  top: 64px;
  left: 0;
  bottom: 0;
  font-size: 14px;
  color: #cccccc;
  box-shadow: 10px 0 10px -10px #19191f;
  overflow-y: auto;

  ul {
    list-style: none;
    margin: 0;
    border: 0;
    padding: 0;
  }

  .filter-title {
    font-size: 17px;
    line-height: 1;
    padding: 17px;
    color: #fff;
    border-bottom: 1px solid #2a282e;
    margin: 0;
  }

  .filter-subtitle {
    font-size: 16px;
    line-height: 1;
    padding: 16px;
    color: #6eecb9;
    border-bottom: 1px solid #2a282e;
    margin: 0;
  }
  .filter-subtitle-positive {
    font-size: 16px;
    line-height: 1;
    padding: 16px;
    color: #ff6c75;
    border-bottom: 1px solid #2a282e;
  }

  .filter-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 2;
    padding: 8px 13px 8px 18px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

    & > .color-checkbox {
      flex-shrink: 0;
    }

    &:not(:last-child)::after {
      display: inline-block;
      content: "";
      width: 216px;
      height: 1px;
      background-color: #2a282e;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    &.selected {
      color: #ffffff;

      &.multiple > .color-checkbox {
        opacity: 1;
      }
    }

    &.filter-all {
      padding-left: 38px;

      &::before {
        display: inline-block;
        content: "";
        width: 16px;
        height: 16px;
        background-size: contain;
        position: absolute;
        top: 50%;
        margin-top: -8px;
        left: 18px;
        opacity: 0;
      }

      &.negative::before {
        background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuMjUgMi45NjloLTEuMDkyYS40OTguNDk4IDAgMCAwLS4zOTIuMTlMNi4zMjMgMTEuMzIgMy4yMzQgNy40MDZhLjUuNSAwIDAgMC0uMzkyLS4xOUgxLjc1YS4xMjUuMTI1IDAgMCAwLS4wOTguMjAxbDQuMjggNS40MjJjLjIuMjUzLjU4NC4yNTMuNzg1IDBsNy42MzEtOS42N2EuMTI0LjEyNCAwIDAgMC0uMDk4LS4yeiIgZmlsbD0iIzZFRUNCOSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+")
          no-repeat;
      }

      &.positive::before {
        background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuMjUgMi45NjloLTEuMDkyYS40OTguNDk4IDAgMCAwLS4zOTIuMTlMNi4zMjMgMTEuMzIgMy4yMzQgNy40MDZhLjUuNSAwIDAgMC0uMzkyLS4xOUgxLjc1YS4xMjUuMTI1IDAgMCAwLS4wOTguMjAxbDQuMjggNS40MjJjLjIuMjUzLjU4NC4yNTMuNzg1IDBsNy42MzEtOS42N2EuMTI0LjEyNCAwIDAgMC0uMDk4LS4yeiIgZmlsbD0iI0ZGNkM3NSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+")
          no-repeat;
      }

      &.selected::before {
        opacity: 1;
      }
    }

    &:hover {
      background-color: #2a282e;

      & > .color-checkbox {
        opacity: 1;
      }
    }

    & > .color-checkbox {
      margin-right: 6px;
      background-color: #010116;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    }
  }
}

.area-news-content {
  padding: 24px 48px 24px 262px;
  .all-provinces {
    display: flex;

    .province-map {
      flex-grow: 1;
    }

    .province-top {
      flex-shrink: 0;
      width: 265px;
      background-color: rgba(15, 15, 21, 0.8);
      border-radius: 8px;
      min-height: 250px;
      .ranking-header {
        padding:20px 24px;
        color: #ffffff;
        font-size: 16px;
        font-family: DIN-Bold;
      }
    }
  }
  .show-time {
      margin-bottom:8px;
      font-size: 14px;
      font-family: DIN-Regular;
    .show-time-title {
      display: inline-block;
      margin-right:8px;
      color: rgba(255, 255, 255, 0.6);
    }
    .show-time-content {
      display: inline-block;
      color:#ffffff;
    }
  }
  .one-province-detail {
    padding-top: 40px;
    border-radius: 8px;
    overflow: hidden;
    display: flex;

    .area-news-bottom {
      flex-grow: 1;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      background-color: #2c2a31;
      .area-news-list {
        .news-item-container {
          padding: 10px 32px;
          border-left: none;
          border-right: none;
          border-bottom: 1px solid #19191f;
          &:hover {
            background-color: #343239;
          }
        }
        .area-news-list-header {
          height: 81px;
          line-height: 81px;
          border-bottom: 1px solid #19191f;
          color: #ffffff;
          font-size: 24px;
          font-family: DIN-Bold;
          border-bottom: 1px soild #19191f !important;
          .news-region {
            margin-left:32px;
            display: inline-block;
          }
          .news-sentiment {
            display: inline-block;
            margin: 0 10px;
          }
          .news-word {
            display: inline-block;
          }
        }
      }
    }

    .type-top {
      width: 265px;
      flex-shrink: 0;
      background-color: #252329;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      .ranking-header {
        height: 58px;
        line-height: 58px;
        padding-left: 24px;
        color: #ffffff;
        font-size: 16px;
        font-family: DIN-Bold;
      }
    }
  }
}
.pager {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  & /deep/ {
    .el-pagination {
      .el-pager li {
        margin: 0 0.125rem;
        background: none;
        border-radius: 0;
        color: #b3b2b3;
        font-family: "DIN-Regular";
        min-width: 32px;
        height: 32px;
        line-height: 32px;

        &.active {
          color: #fff;
          font-family: "DIN-Bold";
          background-color: #26242b;
          border-radius: 54px;
        }

        &:hover {
          background-color: #333137;
          border-radius: 54px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        border: 0.0625rem solid #c2c2c2;
        &:focus {
          border-radius: 0;
          border: 0.0625rem solid #c2c2c2;
        }
      }
      .btn-prev,
      .btn-next {
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
        .el-icon-arrow-right:before {
          color: #fff;
        }
        &:hover {
          background-color: #333333;
          border-radius: 54px;
          .el-icon-arrow-left:before {
            color: #e8e8e8;
          }
          .el-icon-arrow-right:before {
            color: #e8e8e8;
          }
        }
      }
      .btn-prev[class="btn-prev disabled"] {
        border-radius: 54px;
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
      }
      .btn-next[class="btn-next disabled"] {
        background: none;
        border-radius: 54px;
        .el-icon-arrow-right:before {
          color: #fff;
        }
      }
      button {
        padding: 0;
        min-width: 32px;
        height: 32px;
        line-height: 32px;
      }
      .el-pagination__jump {
        color: #ffffff;
        .el-input__inner {
          border: solid 1px #4e4a4d;
          border-radius: 4px;
          color: #ffffff;
          background-color: #39363b;
          &:hover {
            border: solid 1px #868285;
          }
          &:active {
            background-color: #333137;
            border: solid 1px #868285;
          }
        }
      }
    }
  }
}
// ::-webkit-scrollbar-track-piece {
//   width: 6px;
//   background-color: #423f43;
// }
// ::-webkit-scrollbar {
//   width: 6px;
//   height: 6px;
// }
// ::-webkit-scrollbar-thumb {
//   height: 70px;
//   background: rgba(255, 255, 255, 0.2);
//   cursor: pointer;
//   border-radius: 4px;
// }
// ::-webkit-scrollbar-thumb:hover {
//   background-color: #ffffff;
// }

.news-dialog {
  &_title {
    height: 54px;
    line-height: 52px;
    padding-left: 20px;
    font-size: 18px;
    color: #fff;
    border-bottom: 1px solid #4e4a4d;
  }
  .news-list-box {
    height: 60vh;
    overflow-y: auto;
    .no-data-container {
      height: 500px;
    }
  }
  /deep/ .el-dialog__wrapper {
    background: rgba(38, 36, 43, 0.9);
    .el-dialog {
      width: 900px;
      position: relative;
      margin-top: 13vh !important;
      border-radius: 8px;
      border: solid 1px #3e393b;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 14px;
          background-color: #999999;
          border-radius: 50%;
          .el-dialog__close {
            color: #514d4f;
          }
          &:hover {
            width: 24px;
            height: 24px;
            background-color: #fff;
            border-radius: 50%;
          }
        }
      }
      .el-dialog__body {
        background: #423f43;
        padding: 0;
        .search-news-list-container {
          .filter {
            height: 54px;
            justify-content: center;
            span {
              display: none;
            }
            div {
              display: none;
            }
            border-bottom: 1px solid #4e4a4d;
            padding-bottom: 22px;
          }
          .result-container {
            height: 60vh;
            overflow-y: auto;
            margin-top: 0;
            // &::-webkit-scrollbar-track-piece {
            //   background-color: rgba(0, 0, 0, 0);
            //   border-left: 1px solid rgba(0, 0, 0, 0);
            // }
            // &::-webkit-scrollbar {
            //   width: 8px;
            //   height: 34px;
            // }
            // &::-webkit-scrollbar-thumb {
            //   background-color: #676366;
            //   background-clip: padding-box;
            //   min-height: 28px;
            // }
            // &::-webkit-scrollbar-thumb:hover {
            //   background-color: #999999;
            // }
          }
        }
      }
    }
  }
}
.province-map-content {
  background: #19191f;
}
</style>
